import defaultTheme from "./default";
import darkTheme from "./dark";
import { createTheme } from '@mui/material/styles';
export default {
  default: createTheme({ ...defaultTheme as any, ...defaultTheme.overrides }),
  dark: createTheme({ ...darkTheme as any, ...darkTheme.overrides }),
};
